export default {
  'sendpasswordsuccessfully.and': 'و',
  'sendpasswordsuccessfully.successfully': 'موفقیت آمیز بود',
  'sendpasswordsuccessfully.sendpassword': 'رمز عبور با موفقیت ارسال گردید',
  'sendpasswordsuccessfully.passwordsentto': 'ارسال لینک بازیابی رمز عبور به ایمیل ',
  'sendpasswordsuccessfully.checkemail':
    'برای تنظیم مجدد رمز عبور لطفا ایمیل خود را بررسی کنید',
};
